import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { MultiSelectOption } from "../../../models/MultiSelectOption";
import { getBuildingNamesWithPagination } from "../../../services/buildingService";
import { getControllerNamesWithPagnation } from "../../../services/controllerService";
import { getFloorsNamesWithPagination } from "../../../services/floorService";
import { getReaderNamesWithPagination } from "../../../services/readerService";
import { getZoneNamesWithPagination } from "../../../services/zoneService";
import { appendFilter } from "../../../utilities/filters";

interface SummaryProps {
    onBack: (event: any) => void;
    type: string;
}

const Summary: FC<SummaryProps> = ({ onBack, type }) => {
    const { translate } = useLocale();
    const { values, setFieldValue } = useFormikContext<any>();
    const [selectedItems, setSelectedItems] = useState<MultiSelectOption[]>([]);
    const [entityName, setEntityName] = useState<string>("");

    useEffect(() => {
        getFilterWithNames();
    }, [values.filterIds])

    const getFilterWithNames = async () => {
        try {
            let names: MultiSelectOption[] = [];

            switch (type) {
                case "controller":
                    names = (await getControllerNamesWithPagnation({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.controllers));
                    break;
                case "zone":
                    names = (await getZoneNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.zones));
                    break;
                case "reader":
                    names = (await getReaderNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.readers));
                    break;
                case "building":
                    names = (await getBuildingNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.buildings));
                    break;
                case "floor":
                    names = (await getFloorsNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.floors));
                    break;
            }

            setSelectedItems(names);
            setFieldValue("filterNames", names);
            return names;
        } catch (error) {

        }
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <span className={`mb-3 text-portal-blue-primary text-xl font-semibold`}>
            {translate.byKey(TranslationKeys.summary)}
        </span>
        <div className="flex flex-col">
            <div className="flex flex-row flex-1">
                <h4 className="p-1 text-xs text-gray-600 w-1/3">{translate.byKey(TranslationKeys.filter)}</h4>
                <div className="flex flex-col w-1/3">
                    <span className="p-1 text-sm">{entityName}</span>
                </div>
            </div>
            
            <div className="flex flex-row flex-1">
                <h4 className="p-1 text-xs text-gray-600 w-1/3">{entityName}</h4>
                <ul className="flex flex-col w-1/3">
                    {selectedItems.map((item: MultiSelectOption) => {
                        { return <li key={item.value} className="p-1 text-sm">{item.label}</li> }
                    })}
                </ul>
            </div>

        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type='submit'>{translate.byKey(TranslationKeys.submit)}</button>
            </div>
        </div>
    </div>
}

export default Summary;